import { pushData, formatSectionData } from '@ynap/live-chat'

type PushToLiveChatType = (
    data: { event: string } & { page?: gtmPageTrackingObj },
    lpTag?: { additionalSections?: string[] }
) => void

/**
 * @param data analytics data
 * @param lpTag so components can cammunicate with this script through react-track dispatch system
 */
const pushDataToLiveChat: PushToLiveChatType = (data, lpTag) => {
    const shouldPushToLiveChat = data.event == 'trackPage' || !!lpTag?.additionalSections

    if (shouldPushToLiveChat) {
        const additionalPageData = (lpTag?.additionalSections && !data.page) ? [...lpTag.additionalSections, ...(window as any)?.lpTag?.section || []] : []
        const additionalSections = ['myaccount', ...additionalPageData]
        const country: string | undefined = data.page?.pageInfo?.geoRegion?.toUpperCase()
        const liveChatCountry = country === 'US' ? country : undefined
        liveChatCountry && additionalSections.push(liveChatCountry)
        const sectionData = formatSectionData({ ...data.page, additionalSections })

        sectionData.length && pushData({ sectionData })
    }
};

export default pushDataToLiveChat;